import { Box } from '@mui/material'

import {
  BackdropPopup,
  ButtonApp,
  LoadingBackdrop,
  TextBold,
} from 'presentation/components/elements'
import { changeNotificationsReading } from 'presentation/constant/texts/notification'
import { useNotificationsAsRead } from 'presentation/redux/hooks/notifications/useNotificationsAsRead'
import { cancelText, continueText } from 'presentation/constant/globals'

type RecoverPasswordPopupProps = {
  openBackdrop: boolean
  handleCloseBackdrop: () => void
  idsArray: any
  handleCloseNotificationsMenu: () => void
  handleNotifications: () => void
  isLoading: boolean
}

export default function NavItemPopup({
  openBackdrop,
  handleCloseBackdrop,
  handleCloseNotificationsMenu,
  idsArray,
  handleNotifications,
  isLoading,
}: RecoverPasswordPopupProps) {
  const { createNotificationsAsRead } = useNotificationsAsRead()
  const handleNotificationRead = async () => {
    await createNotificationsAsRead(idsArray)
    handleCloseNotificationsMenu()
    handleCloseBackdrop()
    handleNotifications()
  }

  return (
    <BackdropPopup openBackdrop={openBackdrop}>
      {isLoading && <LoadingBackdrop />}
      <Box sx={{ textAlign: 'center', width: '700px' }}>
        <TextBold fontSize="24px" lineHeight="30px" color="info.main">
          {changeNotificationsReading}
        </TextBold>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          marginTop: '40px',
        }}
      >
        <ButtonApp isOutlined onClick={handleCloseBackdrop}>
          {cancelText}
        </ButtonApp>
        <ButtonApp isSubmitType onClick={handleNotificationRead}>
          {continueText}
        </ButtonApp>
      </Box>
    </BackdropPopup>
  )
}
